module.exports = {
  serverAddress: 'https://api.malefromhome.com/',
  defaultProviderId: '00000000-0000-0000-0000-000000000000',
  env: 'prod',
  resultUri: 'https://results.malefromhome.com/',
  kitArtifactBucket: 'mfh-kit-artifacts',
  shopifyProviderPortalTag: 'provider_portal_access',
  cognitoPoolId: "us-east-1_Lx8OK6qiu",
  cognitoClientId: "4eibp800rj91rfnknf1tq873ok",
  cognitoRegion: "us-east-1",
  allowedPhoneCountries: 'US'
}
